import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getTeamUsers = unaryRpc({
  name: "getTeamUsers",
  input: z.object({ teamId: z.string() }),
  output: z.array(
    z.object({
      _id: z.string(),
      name: z.string(),
      firstName: z.string(),
      lastName: z.string(),
      email: z.string(),
      managedUserRoles: z.array(z.string()),
    }),
  ),
});
